module.exports = __webpack_public_path__ + "static/culture.mission-544edb72ec2766b6c9e3d89fe3379b22.png";